import { useQuery } from 'react-query'
import { getMoneyPoolManagementBulletins } from 'services/fund'

export default function useGetBulletins(id: string | undefined) {
    const { data, isLoading, refetch } = useQuery(
        ['bulletins', id],
        getMoneyPoolManagementBulletins
    )
    return { bulletins: data, isLoadingBulletins: isLoading, refetch }
}
